import { ClassModel } from './ClassModel';

export class MembershipPlanModel {
    constructor(membershipPlanData) {
        const allowedClasses = this.getAllowedClasses(membershipPlanData);

        this._membershipPlan = {
            id: membershipPlanData.id,
            name: membershipPlanData.name,
            deadlineDate: membershipPlanData.deadline_date,
            deadlineDays: membershipPlanData.deadline_days,
            autoRenew: membershipPlanData.auto_renew,
            credits: membershipPlanData.credits,
            isOnlineOnly: membershipPlanData.online_only,
            regularity: membershipPlanData.regularity,
            price: membershipPlanData.price,
            paymentsCount: membershipPlanData.payments_count,
            signupFee: membershipPlanData.signup_fee,
            allowedClasses,
        };
    }

    get membershipPlan() {
        return this._membershipPlan;
    }

    getAllowedClasses(membershipPlanData) {
        let allowedClasses = [];

        if (membershipPlanData.allowed_classes) {
            allowedClasses = membershipPlanData.allowed_classes.data.map(_class => {
                const classModel = new ClassModel(_class);
                return { ...classModel.__class };
            });
        }

        return allowedClasses;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/MembershipPlanModel.js